import { fromJS } from 'immutable';
import { UPDATE_DEPARTURES } from '../constants/deraptures';

export default function (state, action) {
  switch (action.type) {
    case UPDATE_DEPARTURES:
      return fromJS(action.payload);
    default:
      return state;
  }
}
